import React from "react";
import { useNavigate } from "react-router-dom";
import '../App.css';
import './Home.css';

function Home() {
    const navigate = useNavigate();
    const cards = [
        {
            id: 1,
            title: "Early life",
            description: "Cars, electronics, broken gadgets, and the things that made engineering feel obvious.",
            image: "/images/early.jpg",
            path: "/early-life",
        },
        {
            id: 2,
            title: "Education",
            description: "My academic path through computer engineering at ISEL.",
            image: "/images/isel.jpg",
            path: "/education",
        },
        {
            id: 3,
            title: "FSISEL",
            description: "Formula Student work, electronics, and the fun parts of building an EV with a team.",
            image: "/images/ifs.jpg",
            path: "/fsisel",
        },
        {
            id: 4,
            title: "Personal projects",
            description: "Small tools, class projects, and hardware ideas that came from actual needs.",
            image: "/images/bspd.png",
            path: "/personalprojects",
        },
        {
            id: 5,
            title: "Career",
            description: "From SAS system administration to C++ development.",
            image: "/images/eng.jpg",
            path: "/career",
        },
    ];

    const openCard = (path) => {
        navigate(path);
    };

    return (
        <main className="home-container">
            <section className="intro-text">
                <p>Hi, I'm Goncalo. I like building things.</p>
                <p className="intro-note">
                    Computer engineering student at ISEL, member of FSISEL, currently working in C++ @ Critical TechWorks.
                    Most of my interests live somewhere between software, electronics, cars, and figuring out how things work (or fail).
                </p>
            </section>

            <section aria-labelledby="skills-title">
                <h1 className="ps-st" id="skills-title">Skills</h1>
                <div className="tech-logos-container">
                    <div className="tech-grid">
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" alt="JavaScript" className="tech-logo" />
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React" className="tech-logo" />
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" alt="Node.js" className="tech-logo" />
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg" alt="Java" className="tech-logo" />
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" alt="Python" className="tech-logo" />
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" alt="PostgreSQL" className="tech-logo" />
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" alt="Docker" className="tech-logo" />
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" alt="Git" className="tech-logo" />
                    </div>
                </div>
            </section>

            <section className="card-grid" aria-label="Site sections">
                {cards.map((card) => (
                    <article
                        key={card.id}
                        className="card"
                        onClick={() => openCard(card.path)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                openCard(card.path);
                            }
                        }}
                        role="button"
                        tabIndex="0"
                    >
                        <img src={card.image} alt="" className="card-img" />
                        <div className="card-content">
                            <h2 className="card-title">{card.title}</h2>
                            <p className="card-description">{card.description}</p>
                            <span className="card-button">Open</span>
                        </div>
                    </article>
                ))}
            </section>
        </main>
    );
}

export default Home;
